import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import { updateValidityPeriodQuery } from '@app/pcs/data/calendar-edit.queries';

@Injectable()
export class CalendarEditService {
  constructor(private graphqlService: GraphqlService) {
  }

  updateValidityPeriod(templateCalendar, validityPeriod, existingPath) {
    return this.graphqlService.query(updateValidityPeriodQuery, {
      templateCalendar,
      validityPeriod,
      existingPath
    }, hideLoader());
  }
}
